import axios from 'axios'
const API_URL = "https://blooggerr.onrender.com/admin/category/"
// const API_URL = "http://localhost:8080/admin/category/"

function getCategories(){
    console.log("GET")
    return axios.get(`${API_URL}all`)
}

function getCategory(id){
    console.log("GET" + id)
    return axios.get(`${API_URL}${id}`)
}

export {getCategories, getCategory}
